import React, { useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import ApproachSection from '../components/ApproachSection';
import BehandlungenSection from '../components/BehandlungenSection';
import BenefitsSection from '../components/BenefitsSection';
import BeforeAfterGallery from '../components/BeforeAfterGallery';
import SocialProofSection from '../components/SocialProofSection';
import ExperienceSection from '../components/ExperienceSection';
import TeamSection from '../components/TeamSection';
import CtaSection from '../components/CtaSection';

const HomePage: React.FC = () => {
  useEffect(() => {
    // Set page title for SEO
    document.title = 'SeaDent Mallorca - Moderne Zahnmedizin in Palma';
    
    // Set meta description for SEO
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'SeaDent Mallorca bietet moderne Zahnmedizin in Palma. Entdecken Sie unsere Wohlfühlerfahrung und umfassenden Zahnbehandlungen.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'SeaDent Mallorca bietet moderne Zahnmedizin in Palma. Entdecken Sie unsere Wohlfühlerfahrung und umfassenden Zahnbehandlungen.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <main className="pt-32">
      <HeroSection />
      <ApproachSection />
      <BehandlungenSection />
      <BenefitsSection />
      <BeforeAfterGallery />
      <SocialProofSection />
      <TeamSection />
      <ExperienceSection />
      <CtaSection />
    </main>
  );
};

export default HomePage; 